import React from 'react'
import TombstoneList from '../../TombstoneList/TombstoneList'

const getColorCoding = value => {
  const numberValue = value.replace(/\D+/g, '')
  return numberValue <= 25 ? (numberValue <= 5 ? 'low' : 'medium') : 'high'
}
const formatTombstoneData = (title, data) => {
  return {
    title,
    quantities: [data.servingData[1].servingValue],
    percentage: data.servingData[2]?.servingValue?.replace('*', ''),
    colorCoding: data.servingData[2] && getColorCoding(data.servingData[2]?.servingValue)
  }
}
const extractTombstoneNutritionInfo = data => {
  const formatedFields = []
  const nutritionIds = ['energy', 'fat', 'carbohydrate', 'salt']

  const nutritionData = data.nutritionTable.nutritionData

  // ENERGY
  const energyIndex = nutritionData.findIndex(item => (item.nutrientName || '').toLowerCase().includes(nutritionIds[0]))
  if (nutritionData[energyIndex + 1].nutrientName) {
    // If the KCal entry does not exist, do not show the tombstones
    return []
  }
  const energyInKcal = nutritionData[energyIndex + 1]

  if (energyIndex >= 0) {
    formatedFields.push({
      title: 'Energy',
      quantities: [
        nutritionData[energyIndex].servingData[1].servingValue?.replace('/', ''),
        energyInKcal.servingData[1].servingValue
      ],
      percentage: energyInKcal.servingData[2]?.servingValue?.replace(/\(|\)|\*/g, '')
    })
  }

  // FAT

  const fat = nutritionData.find(item => (item.nutrientName || '').toLowerCase().includes(nutritionIds[1]))
  if (fat) {
    formatedFields.push(formatTombstoneData('Fat', fat))
    if (fat.ofWhich) {
      formatedFields.push(
        formatTombstoneData(
          'Saturates',
          fat.ofWhich.find(item => item.nutrientName.toLowerCase().includes('of which saturates'))
        )
      )
    }
  }

  // SUGARS
  const carbs = nutritionData.find(item => (item.nutrientName || '').toLowerCase().includes(nutritionIds[2]))
  if (carbs && carbs.ofWhich) {
    formatedFields.push(
      formatTombstoneData(
        'Sugars',
        carbs.ofWhich.find(item => item.nutrientName.toLowerCase().includes('of which sugars'))
      )
    )
  }

  // SALT
  const salt = nutritionData.find(item => (item.nutrientName || '').toLowerCase().includes(nutritionIds[3]))
  if (salt) {
    formatedFields.push(formatTombstoneData('Salt', salt))
  }

  return formatedFields
}

const NutritionTombstones = data => {
  const { tombstones } = data
  const dataTest = 'tombstone-list'
  const props = {
    data: tombstones,
    dataTest
  }
  return <TombstoneList {...props} />
}

export { extractTombstoneNutritionInfo, NutritionTombstones }
export default NutritionTombstones
